export default {
	userMe: 'user-me',
	courses: 'courses',
	recoveryPassword: 'recovery-password',
	metadata: 'metadata',
	trainingEmails: 'trainingEmails',
};
